import { gql } from '@apollo/client';

export * from './updateProfileInfo.mutation.generated';

export const UPDATE_PROFILE_INFO = gql`
  mutation updateProfileInfo($name: String!, $phone: String) {
    updateProfileInfo(input: { name: $name, phone: $phone }) {
      success
      errors
      profile {
        id
        name
        email
        phone
      }
    }
  }
`;
